<!--
  Hot Work Permit Form
  
  Step-by-step permit submission with:
  - 7 steps: Permit Details & Location, Requirements Within 35 Feet, Drawings Reviewed, Equipment-Tools-Materials, Items Completed, Atmospheric Monitoring, Permit Approvals
  - Dynamic personnel management (up to 4 persons performing work)
  - Conditional utility location fields based on locate status
  - Comprehensive safety checklist for hot work activities
  - Atmospheric monitoring with safety guidelines
  - Form validation for hot work safety compliance
-->

<!-- Use the form layout component to handle the wizard UI -->
<app-form-layout
  [title]="formTitle"
  [form]="form"
  [icon]="formIcon"
  [disabled]="submitting"
  [onSubmit]="onSubmit.bind(this)"
  [steps]="steps"
  [currentStep]="currentStep()"
  [completedSteps]="completedSteps()"
  [canNavigateToStep]="canNavigateToStep.bind(this)"
  [isStepCompleted]="isStepCompleted.bind(this)"
  [onNextStep]="onNextStep.bind(this)"
  [onPreviousStep]="onPreviousStep.bind(this)"
  [getProgressPercentage]="getProgressPercentage.bind(this)"
>
  <div
    *ngIf="form && fieldMappings"
    formContent
    [formGroup]="form"
    class="form-content"
  >
    <!-- Permit Details & Location Step -->
    <div *ngIf="currentStep() === steps[0].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[0].title }}</h1>
            <p>{{ steps[0].description }}</p>
          </ion-label>
        </ion-item-divider>


          <ion-card color="danger" class="information-card">
            <ion-card-header>  <ion-card-title><ion-icon name="hand-left-outline"></ion-icon>&nbsp; <strong>Stop!</strong></ion-card-title></ion-card-header>
            <ion-card-content>
              <ion-text>
                <h2>
            Before starting hot work, review all safety precautions. <br>Can this work be avoided
                  or is there a safer way? If so, <strong>do not authorize work!</strong> <br>This hot
                  work permit is required whenever using open flames, or when
                  welding or grinding within 35 feet of flammables. <br>This permit
                  expires in 24 hours or when conditions change.
                  </h2>
              </ion-text>
            </ion-card-content>
          </ion-card>

        <ion-grid>
          <ion-row>
            <ion-col size="12">
              <app-date-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('date')!"
                [label]="fieldMappings['date']"
                [requiredField]="requiredFields['date']"
                [today]="true"
            
              >
              </app-date-input>
            </ion-col>
            </ion-row>
            <ion-row>
            <ion-col size="12">
              <app-textarea-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('descriptionOfWork')!"
                [label]="fieldMappings['descriptionOfWork']"
                [requiredField]="requiredFields['descriptionOfWork']"
                [rows]="3"
                placeholder="Describe the work to be performed"
              >
              </app-textarea-input>
            </ion-col>
         
          </ion-row>


          <ion-row>
            <ion-col size="12">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('supervisorForeman')!"
                [label]="fieldMappings['supervisorForeman']"
                [requiredField]="requiredFields['supervisorForeman']"
                placeholder="Enter supervisor/foreman name"
              >
              </app-text-input>
            </ion-col>
            </ion-row>
            <ion-row>
            <ion-col size="12">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('recipientEmail')!"
                [label]="fieldMappings['recipientEmail']"
                [requiredField]="requiredFields['recipientEmail']"
                placeholder="email@domain.com"
                type="email"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

          
         

            <!-- Personnel List -->
            <ion-row class="ion-no-margin ion-margin-top">
          <ion-item-divider class="form-subsection-title ion-margin-top">
            <ion-label>
              <h2>{{ steps[0].sections?.[1]?.subtitle }}</h2>
            </ion-label>
          </ion-item-divider>
          </ion-row>

          <!-- Fire Watch Personnel Note-->
          <ion-row class="ion-no-padding ion-no-margin ">
            <ion-card color="warning" class="information-card">
              <ion-card-content>
                <ion-text>
                  <h5>
                <strong> <ion-icon name="man-outline"></ion-icon>&nbsp;NOTE:  <br>"Fire Watch" Personnel
                must be present during hot work and remain on watch for a
                sufficient period of time (a minimum of 30 minutes) after
                completion of work to ensure that no possibility of fire exists.
                </strong>
                  </h5>
                </ion-text>
              </ion-card-content>
            </ion-card>
          </ion-row>
        
        
     <!-- Persons Performing Work -->
          <ion-row [class.ion-no-padding]="!showPersonsPerformingWorkIndex[2]"
          [class.ion-no-margin]="!showPersonsPerformingWorkIndex[2]">
                <!-- Person 1 -->
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('person1')!"
                [label]="fieldMappings['person1']"
                [requiredField]="requiredFields['person1']"
                placeholder="Enter person name"
              >
              </app-text-input>
            </ion-col>
            <!-- Person 2 -->
            <ion-col size="12" size-md="6"
            *ngIf="showPersonsPerformingWorkIndex[1]">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('person2')!"
                [label]="fieldMappings['person2']"
                placeholder="Enter person name (optional)"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

        

          <!-- Person 3 -->
          <ion-row  *ngIf="showPersonsPerformingWorkIndex[2]"
          class="ion-no-padding ion-no-margin">
            <ion-col 
            size="12" size-md="6"
            *ngIf="showPersonsPerformingWorkIndex[2]">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('person3')!"
                [label]="fieldMappings['person3']"
                placeholder="Enter person name (optional)"
              >
              </app-text-input>
            </ion-col>
            <ion-col 
            size="12" size-md="6"
            *ngIf="showPersonsPerformingWorkIndex[3]">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('person4')!"
                [label]="fieldMappings['person4']"
                placeholder="Enter person name (optional)"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

          <!-- Add Person Performing Work Button -->
          <ion-row class="ion-no-padding ion-no-margin ion-align-items-center ">
            <ion-button (click)="addPersonPerformingWork()" fill="clear"
            [title]="showAddPersonPerformingWorkButton ? 'Add Person Performing Work' : ''"
            [disabled]="!showAddPersonPerformingWorkButton"
          >
            <ion-icon
              name="add-circle-outline"
              slot="icon-only"
            ></ion-icon>
          </ion-button>
          <ion-text *ngIf="!showAddPersonPerformingWorkButton" class="add-other-button-text"
            >Maximum Reached</ion-text
          >
          <ion-text *ngIf="showAddPersonPerformingWorkButton" color="primary"
          >Add Person Performing Work</ion-text
        >
        </ion-row>

    


        <!-- Location -->
         <ion-row class="ion-no-margin ion-margin-top">
        <ion-item-divider class="form-subsection-title ion-margin-top">
          <ion-label>
            <h2>{{ steps[0].sections?.[2]?.subtitle }}</h2>
          </ion-label>
        </ion-item-divider>
</ion-row>
          <!-- Work Location Section -->
          <ion-row>
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('workLocation1')!"
                [label]="fieldMappings['workLocation1']"
                [requiredField]="requiredFields['workLocation1']"
                placeholder="Enter primary work location"
              >
              </app-text-input>
            </ion-col>
  
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('workLocation2')!"
                [label]="fieldMappings['workLocation2']"
                placeholder="Enter additional work location (optional)"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

          <ion-row>

            <ion-card color="warning" class="information-card">
              <ion-card-content>
                <ion-text >
                  <h5>
                <strong> <ion-icon name="radio-outline"></ion-icon>&nbsp;NOTE:  <br>Locate must be
                done if any digging (including hand tool use) will be done or if
                snaking outside the building or when snaking could end up
                outside the building. <br>
                Call 811 to get locate done if not already. <br>
                Allow 2 days for locate to be done.
                </strong>
                  </h5>
                </ion-text>
              </ion-card-content>
            </ion-card>
            
          </ion-row>
          <ion-row>
            <ion-col size="12" size-md="6">
              <app-radio-group-input
                [templateFormGroup]="permitDetailsFormGroup"
                [control]="permitDetailsFormGroup.get('locateDone')!"
                [label]="fieldMappings['locateDone']"
                [requiredField]="requiredFields['locateDone']"
                [options]="['Yes', 'No']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>

          <!-- If locateDone is Yes, then show the locateDate field -->
          <ng-container
            *ngIf="permitDetailsFormGroup.get('locateDone')?.value === 'Yes'"
          >
            <ion-row>
              <ion-card color="warning" class="information-card" >
                <ion-card-content>
                  <ion-text color="dark">
                    <h5>
                      <strong>
                  <ion-icon name="hourglass-outline"></ion-icon>&nbsp;Reminder: <br>Locates Expire
                  after 45 days. <br>Call for refresh if older than 45 days.
                      </strong>
                    </h5>
                  </ion-text>
                </ion-card-content>
              </ion-card>
            </ion-row>
            <ion-row>
              <ion-col>
                <app-date-input
                  [templateFormGroup]="permitDetailsFormGroup"
                  [control]="permitDetailsFormGroup.get('locateDate')!"
                  [label]="fieldMappings['locateDate']"
                  [requiredField]="true"
                 
                >
                </app-date-input>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <app-textarea-input
                  [templateFormGroup]="permitDetailsFormGroup"
                  [control]="permitDetailsFormGroup.get('utilitiesLocated')!"
                  [label]="fieldMappings['utilitiesLocated']"
                  [rows]="2"
                  [requiredField]="true"
                  placeholder="(If Not Applicable Put N/A)"
                >
                </app-textarea-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-img src="assets/Hot-Work-Chart.jpg.png" alt="Hot Work Chart"></ion-img>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <app-textarea-input
                  [templateFormGroup]="permitDetailsFormGroup"
                  [control]="permitDetailsFormGroup.get('utilityProtection')!"
                  [label]="fieldMappings['utilityProtection']"
                  [rows]="2"
                  [requiredField]="true"
                  placeholder="Describe how utilities will be protected"
                >
                </app-textarea-input>
              </ion-col>
            </ion-row>
          </ng-container>


        </ion-grid>
      </ion-list>
    </div>

    <!-- Requirements Within 35 Feet Step -->
    <div *ngIf="currentStep() === steps[1].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[1].title }}</h1>
            <p>{{ steps[1].description }}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="requirements35FeetFormGroup"
                [control]="requirements35FeetFormGroup.get('flammableMaterialsRemoved')!"
                [label]="fieldMappings['flammableMaterialsRemoved']"
                [requiredField]="requiredFields['flammableMaterialsRemoved']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="requirements35FeetFormGroup"
                [control]="requirements35FeetFormGroup.get('floorWallOpeningsCovered')!"
                [label]="fieldMappings['floorWallOpeningsCovered']"
                [requiredField]="requiredFields['floorWallOpeningsCovered']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="requirements35FeetFormGroup"
                [control]="requirements35FeetFormGroup.get('sparkPathEvaluated')!"
                [label]="fieldMappings['sparkPathEvaluated']"
                [requiredField]="requiredFields['sparkPathEvaluated']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="requirements35FeetFormGroup"
                [control]="requirements35FeetFormGroup.get('ductsShutDown')!"
                [label]="fieldMappings['ductsShutDown']"
                [requiredField]="requiredFields['ductsShutDown']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>

    <!-- Drawings Reviewed Step -->
    <div *ngIf="currentStep() === steps[2].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[2].title }}</h1>
            <p>{{ steps[2].description }}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="drawingsReviewedFormGroup"
                [control]="drawingsReviewedFormGroup.get('flowDiagrams')!"
                [label]="fieldMappings['flowDiagrams']"
                [requiredField]="requiredFields['flowDiagrams']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="drawingsReviewedFormGroup"
                [control]="drawingsReviewedFormGroup.get('undergroundSystems')!"
                [label]="fieldMappings['undergroundSystems']"
                [requiredField]="requiredFields['undergroundSystems']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="drawingsReviewedFormGroup"
                [control]="drawingsReviewedFormGroup.get('electricalPneumatic')!"
                [label]="fieldMappings['electricalPneumatic']"
                [requiredField]="requiredFields['electricalPneumatic']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="drawingsReviewedFormGroup"
                [control]="drawingsReviewedFormGroup.get('drainsStorageSystems')!"
                [label]="fieldMappings['drainsStorageSystems']"
                [requiredField]="requiredFields['drainsStorageSystems']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>

    <!-- Equipment-Tools-Material Step -->
    <div *ngIf="currentStep() === steps[3].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[3].title }}</h1>
            <p>{{ steps[3].description }}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="equipmentToolsMaterialsFormGroup"
                [control]="equipmentToolsMaterialsFormGroup.get('faceShield')!"
                [label]="fieldMappings['faceShield']"
                [requiredField]="requiredFields['faceShield']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="equipmentToolsMaterialsFormGroup"
                [control]="equipmentToolsMaterialsFormGroup.get('fireExtinguishingEquipment')!"
                [label]="fieldMappings['fireExtinguishingEquipment']"
                [requiredField]="requiredFields['fireExtinguishingEquipment']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="equipmentToolsMaterialsFormGroup"
                [control]="equipmentToolsMaterialsFormGroup.get('cottonWoolClothing')!"
                [label]="fieldMappings['cottonWoolClothing']"
                [requiredField]="requiredFields['cottonWoolClothing']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="equipmentToolsMaterialsFormGroup"
                [control]="equipmentToolsMaterialsFormGroup.get('fireRetardantClothing')!"
                [label]="fieldMappings['fireRetardantClothing']"
                [requiredField]="requiredFields['fireRetardantClothing']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>

    <!-- Items Completed Step -->
    <div *ngIf="currentStep() === steps[4].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title" >
          <ion-label>
            <h1>{{ steps[4].title }}</h1>
            <p>{{ steps[4].description }}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('linesPurged')!"
                [label]="fieldMappings['linesPurged']"
                [requiredField]="requiredFields['linesPurged']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('linesClean')!"
                [label]="fieldMappings['linesClean']"
                [requiredField]="requiredFields['linesClean']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('drainsSewersCovered')!"
                [label]="fieldMappings['drainsSewersCovered']"
                [requiredField]="requiredFields['drainsSewersCovered']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('valvesClosed')!"
                [label]="fieldMappings['valvesClosed']"
                [requiredField]="requiredFields['valvesClosed']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('energySystemsLockedOut')!"
                [label]="fieldMappings['energySystemsLockedOut']"
                [requiredField]="requiredFields['energySystemsLockedOut']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('blindsInstalled')!"
                [label]="fieldMappings['blindsInstalled']"
                [requiredField]="requiredFields['blindsInstalled']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <app-radio-group-input
                [templateFormGroup]="itemsCompletedFormGroup"
                [control]="itemsCompletedFormGroup.get('systemsDeenergized')!"
                [label]="fieldMappings['systemsDeenergized']"
                [requiredField]="requiredFields['systemsDeenergized']"
                [options]="['Yes', 'No', 'N/A']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>

    <!-- Atmospheric Monitoring Step -->
    <div *ngIf="currentStep() === steps[5].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[5].title }}</h1>
            <ion-text color="danger">
              <h5><ion-icon name="alert-circle"></ion-icon>&nbsp;{{ steps[5].description }}</h5>
            </ion-text>
            
          </ion-label>
                 
        </ion-item-divider>

        <ion-grid>
       
            <ion-row>
              <ion-card color="warning">
                <ion-card-content>
                  <ion-text color="dark">
                    <h5>
                      <strong>
                        <ion-icon name="warning-outline"></ion-icon>&nbsp;
                        Continuous monitoring is required for the duration of hot work when the possibility of a hazardous atmosphere exists.
                        <br> (This does not take the place of a Permit Required Confined Space Permit)  
                      </strong>
                    </h5>
                  </ion-text>
                </ion-card-content>
              </ion-card>
            </ion-row>
            <ion-row>
            <ion-col>
              <ion-text color="success">
                <h5><ion-icon name="speedometer-outline"> </ion-icon>&nbsp;
                  Safe O2 Range is 19.5 to 23.5%               
                </h5> </ion-text>
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('oxygenLevel')!"
                [label]="fieldMappings['oxygenLevel']"
                placeholder="Enter oxygen percentage"
              >
              </app-text-input>
            </ion-col>
            </ion-row>

           
            <ion-row>
              <ion-col>

                <ion-text color="success">
                  <h5><ion-icon name="speedometer-outline"></ion-icon>&nbsp;
                    Less than 10% is Safe             
                  </h5> </ion-text>
              
          
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('combustibleLevel')!"
                [label]="fieldMappings['combustibleLevel']"
                placeholder="Enter combustible percentage of LEL"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

   

          <ion-row>
            <ion-col>
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('carbonMonoxideLevel')!"
                [label]="fieldMappings['carbonMonoxideLevel']"
                placeholder="Enter CO level in PPM"
              >
              </app-text-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              

              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('hydrogenSulfideLevel')!"
                [label]="fieldMappings['hydrogenSulfideLevel']"
                placeholder="Enter H2S level in PPM"
              >
              </app-text-input>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('samplingEquipmentType')!"
                [label]="fieldMappings['samplingEquipmentType']"
                placeholder="Enter equipment type"
              >
              </app-text-input>
            </ion-col>
  
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('samplingConductedBy')!"
                [label]="fieldMappings['samplingConductedBy']"
                placeholder="Enter name of person conducting sampling"
              >
              </app-text-input>
            </ion-col>
            </ion-row>
            <ion-row *ngIf="atmosphericMonitoringFormGroup.get('calibrationCurrent')?.value === 'No'">
              <ion-card color="warning">
                <ion-card-content>
                  <ion-text color="dark">
                    <h5>
                      <strong>
                        <ion-icon name="alert-circle"></ion-icon>&nbsp;
                        If calibration is not current, stop and get a new gas monitor.       
                      </strong>
                    </h5>
                  </ion-text>
                </ion-card-content>
              </ion-card>
              
            </ion-row>

            <ion-row>
            <ion-col size="12" size-md="4">
              <app-radio-group-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('calibrationCurrent')!"
                [label]="fieldMappings['calibrationCurrent']"
                [options]="['Yes', 'No']"
                [orientation]="'horizontal'"
              >
              </app-radio-group-input>
            </ion-col>
      
            <ion-col size="12" size-md="4">
              <app-date-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('samplingDate')!"
                [label]="fieldMappings['samplingDate']"
                placeholder="Enter sampling date"
              >
              </app-date-input>
            </ion-col>
            <ion-col size="12" size-md="4">
              <app-text-input
                [templateFormGroup]="atmosphericMonitoringFormGroup"
                [control]="atmosphericMonitoringFormGroup.get('samplingTime')!"
                [label]="fieldMappings['samplingTime']"
                [type]="'time'"
                placeholder="Enter sampling time"
              >
              </app-text-input>
            </ion-col>
          </ion-row>
 
        </ion-grid>
      </ion-list>
    </div>

    <!-- Permit Approvals Step -->
    <div *ngIf="currentStep() === steps[6].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[6].title }}</h1>
           
          </ion-label>
        </ion-item-divider>
        <ion-card color="danger" class="information-card">
          <ion-card-header><ion-card-title><ion-icon name="alert-circle"></ion-icon>&nbsp;Special Instructions For Utility Work:</ion-card-title></ion-card-header>
          <ion-card-content>
            <ion-text>
              <h5>
                All utility work performed outside the building requires Supervisor visit and approval. <br>The Safety Department must be called and approve any hot work <strong>within 5 feet of utilities.</strong>
              </h5>
            </ion-text>
          </ion-card-content>
        </ion-card>

   

        <ion-grid>
          <ion-row>
            <ion-col>
              <app-text-input
                [templateFormGroup]="approvalsFormGroup"
                [control]="approvalsFormGroup.get('initiatedBy')!"
                [label]="fieldMappings['initiatedBy']"
                [requiredField]="requiredFields['initiatedBy']"
                placeholder="Enter name of person initiating permit"
              >
              </app-text-input>
            </ion-col>
          </ion-row>


          <ion-row>
            <ion-col>
              <app-text-input
                [templateFormGroup]="approvalsFormGroup"
                [control]="approvalsFormGroup.get('approvedBy')!"
                [label]="fieldMappings['approvedBy']"
                [requiredField]="requiredFields['approvedBy']"
                placeholder="Enter name of person approving permit"
              >
              </app-text-input>
            </ion-col>
          </ion-row>
          <ion-row >
            <ion-card color="warning">
              <ion-card-content>
                <ion-text color="dark">
                  <h5>
                    <strong>
                      <ion-icon name="alert-circle"></ion-icon>&nbsp;
                      Retain this permit for duration of the job and file in the Site Safety Manual.      
                    </strong>
                  </h5>
                </ion-text>
              </ion-card-content>
            </ion-card>
          </ion-row>

        </ion-grid>
      </ion-list>
    </div>
  </div>
</app-form-layout>